export const SET_ACTIVE_PROFILE = 'SET_ACTIVE_PROFILE';
export type SET_ACTIVE_PROFILE = typeof SET_ACTIVE_PROFILE;


// WEBPACK FOOTER //
// ./src/actions/active-profile/set/Types.tsx